module.exports = __webpack_public_path__ + "media/images/btn_new_administrated_account-3c81e1bdadec445defc6ccc4f4213309.gif";